import TomSelect from 'tom-select';

export function initCustomerSuccessTagsSelect() {
  const selectElement = document.getElementById('customer-success-tags-select') as HTMLSelectElement;

  if (!selectElement || selectElement.classList.contains('tomselected')) {
    return;
  }

  const existingTags = JSON.parse(selectElement.dataset.tags || '[]');
  const availableTags = JSON.parse(selectElement.dataset.availableTags || '[]');

  const tomSelect = new TomSelect('#customer-success-tags-select', {
    plugins: ['remove_button', 'drag_drop'],
    placeholder: 'Select tags',
    maxItems: availableTags.length,
    valueField: 'value',
    labelField: 'text',
    searchField: ['text'],
    options: availableTags,
    items: existingTags,
    create: false,
    render: {
      item: function(data: any, escape: any) {
        return `<div class="tag-item">
                  <span class="tag-label">${escape(data.text)}</span>
                </div>`;
      },
      option: function(data: any, escape: any) {
        return `<div class="tag-option">
                  <span>${escape(data.text)}</span>
                </div>`;
      }
    },
    onItemAdd: function(value: string, item: HTMLElement) {},
    onItemRemove: function(value: string) {}
  });

  const syncInputVisibility = () => {
    if (tomSelect.items.length >= availableTags.length) {
      tomSelect.control_input.style.setProperty('display', 'none', 'important');
    } else {
      tomSelect.control_input.style.removeProperty('display');
    }
  };
  tomSelect.on('item_add', syncInputVisibility);
  tomSelect.on('item_remove', syncInputVisibility);
  syncInputVisibility();

  return tomSelect;
}
